import React from "react";
import { ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import CheckRounded from "@mui/icons-material/CheckRounded";
import { ENCOUNTER_SETTINGS, NOTE_FORMATS } from "./inpatient";

/**
 * The words are self-evident to a clinician; what each one changes in ChartMind is not, so the
 * menu says that and nothing else.
 */
export const ENCOUNTER_SETTING_OPTIONS = [
  {
    value: ENCOUNTER_SETTINGS.OUTPATIENT,
    label: "Outpatient",
    description: "Clinic or emergency visit note",
  },
  {
    value: ENCOUNTER_SETTINGS.INPATIENT,
    label: "Inpatient",
    description: "Admission, progress, or Events note, with a Daily Plan when needed",
  },
];

/** Inpatient only: the kind of note the Chart step writes. */
export const NOTE_FORMAT_OPTIONS = [
  {
    value: NOTE_FORMATS.ADMISSION,
    label: "Admission H&P",
    description: "Full history and physical for the admission",
  },
  {
    value: NOTE_FORMATS.PROGRESS,
    label: "Progress note",
    description: "Plan-first note for the next hospital day",
  },
  {
    value: NOTE_FORMATS.EVENTS,
    label: "Events",
    description: "Note for the events entered, with a Plan of tests and treatments for those events",
  },
];

const optionLabel = (options, value) =>
  (options.find((o) => o.value === value) || options[0]).label;

export const encounterSettingLabel = (value) => optionLabel(ENCOUNTER_SETTING_OPTIONS, value);
export const noteFormatLabel = (value) => optionLabel(NOTE_FORMAT_OPTIONS, value);

/**
 * The inpatient/outpatient choice (or, given `options`, the note type or specialty), opened from whatever row
 * or button anchors it.
 */
const EncounterSettingMenu = ({ anchorEl, onClose, value, onChange, options = ENCOUNTER_SETTING_OPTIONS }) => (
  <Menu
    anchorEl={anchorEl}
    open={Boolean(anchorEl)}
    onClose={onClose}
    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
    transformOrigin={{ vertical: "top", horizontal: "right" }}
  >
    {options.map((option) => (
      <MenuItem
        key={option.value}
        selected={option.value === value}
        onClick={() => {
          onChange(option.value);
          onClose();
        }}
        sx={{ alignItems: "flex-start", maxWidth: 340 }}
      >
        <ListItemText
          primary={option.label}
          secondary={option.description}
          secondaryTypographyProps={{ sx: { whiteSpace: "normal" } }}
        />
        <ListItemIcon
          sx={{
            justifyContent: "flex-end",
            mt: 0.5,
            visibility: option.value === value ? "visible" : "hidden",
          }}
        >
          <CheckRounded fontSize="small" />
        </ListItemIcon>
      </MenuItem>
    ))}
  </Menu>
);

export default EncounterSettingMenu;
